import React from 'react';
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './SkeletonLoader.css';

import skeletonTemplate from './SkeletonLoader.json';

const SkeletonLoader = (props) => {
  const properties =
    skeletonTemplate.skeletonScreenComponents[props.componentName].properties;
  return (
    <SkeletonTheme>
      <div
        className={'SkeletonLoaderWrapper'}
        data-testid="SkeletonLoaderWrapper"
        id={'SkeletonLoaderWrapper'}
      >
        {properties.map((item, index) => (
          <Skeleton
            data-testid="skeleton-loader"
            key={`skeleton-loader-${index}`}
            animation="wave"
            {...item}
          />
        ))}
      </div>
    </SkeletonTheme>
  );
};

export default SkeletonLoader;
